import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Descriptions,
  Divider,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import { CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG } from "assets";
import { logoFullWhite, logoIconWhite, logoBill } from "assets/images/logo/";
import ReactToPrint from "react-to-print";
import {
  doiTuongOptions,
  gioiTinhOptions,
  doiTuongKCB,
} from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import { payService } from "api";
import { columns, getTodayString } from "./ModalPrint.config";
import { useAppSelector } from "redux/hooks";
import moment from "moment";
import "./ModalPrint.scss";
import Notification from "components/common/notification/notification";
import { ReactComponent as PhoneSVG } from "assets/icons/phone-svg.svg";
import { ReactComponent as MailSVG } from "assets/icons/mail-svg.svg";
import { ReactComponent as InternetSVG } from "assets/icons/internet-svg.svg";
import { formatToCurrencyType } from "helper/common";
import { HeaderPrintForm } from "components/common";
const { Text } = Typography;

const ModalPrint = (props) => {
  const { isShowModal, handleOk, handleCancel, listId = [] } = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [data, setData] = useState([]);
  const idLanKham = useAppSelector((state) => state.reduxCommon.id);
  const idBh = useAppSelector((state) => state.common.idReceiptPrint);
  const [thanhTien, setThanhTien] = useState();
  const [tenThuNgan, setTenThuNgan] = useState<any>();
  console.log("list id hoan phi", listId);

  // const [isModalOpen, setIsModalOpen] = useState(false);

  // const getThanNhan = (hoTen, quanHe) => {
  //   if(hoTen) {
  //     return quanHe ? hoTen + `(${quanHe})`: hoTen
  //   }
  //   return '';
  // }

  useEffect(() => {
    if (isShowModal && listId.length > 0) {
      getData();
    }
    // getDataInfo();
  }, [isShowModal, listId]);

  const getData = async () => {
    const body = {
      list_id: listId,
    };
    try {
      let response = await payService.getDataPrintRefunds(body).then((res) => {
        // console.log("data in phieu hoan phi", res);
        const thongTinNew = {
          ...res.data.data,
          thoiGianHoan: res.data.data.listItem[0].thoiGianHoan
            ? res.data.data.listItem[0].thoiGianHoan
            : "",
        };
        setThongTinIn(thongTinNew);
        const newData = res.data.data.listItem.map((item) => ({
          ...item,
          noiDung: item.noiDung,
          soLuong: item.soLuong,
          donGiaBV: item.donGiaBenhVien,
          donGiaBH: item.donGiaBaoHiem,
          thanhTien: item.thanhTien,
          thoiGianChiDinh: item.ngayChiDinh,
          lyDoHoan: item.lyDoHoan,
          soTienMienGiam: item.soTienMienGiam,
        }));
        const tenThuNganArray = res.data.data.listItem.map(
          (item) => item.nguoiDeNghi
        );
        const uniqueTenThuNganArray = tenThuNganArray.filter(
          (value, index, self) => {
            return self.indexOf(value) === index;
          }
        );
        if (uniqueTenThuNganArray.length == 1) {
          setTenThuNgan(tenThuNganArray[0]);
        }
        if (uniqueTenThuNganArray.length > 1) {
          setTenThuNgan("");
        }
        setData(newData);
        // setThanhTien(res.data.data.thanhTien);
      });
    } catch (err) {
      // Notification("error", "Đã có lỗi xảy ra khi lấy dữ liệu in phiếu");
    }
  };

  // const getDataInfo = async () => {
  //   try {
  //     let response = await payService
  //       .getDataPayPrintPerson(idLanKham)
  //       .then((res) => {
  //         // console.log('data in', res);
  //         setThongTinIn(res.data.data);
  //       });
  //   } catch (err) {
  //     ;
  //   }
  // };

  const onPrint = async () => {
    window.print();
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const calculateSelectedRowsTotal = (dataIndex) => {
    let total = 0;
    for (let i = 0; i < data.length; i++) {
      total += data[i][dataIndex] || 0;
    }
    return total;
  };

  const getDateStringLocale = (dateString: string) => {
    if (!dateString) {
      return "";
    }
    const parts = dateString.split(" ");
    const timePart = parts[0];
    const datePart = parts[1]
      .split("/")
      .map((part) => part.padStart(2, "0"))
      .reverse()
      .join("-");

    const dateTimeString = `${datePart}T${timePart}`;
    const dateObject = new Date(dateTimeString);

    const day = dateObject.getDate().toString().padStart(2, "0");
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const year = dateObject.getFullYear();

    const formattedResult = `Ngày ${day} tháng ${month} năm ${year}`;
    return formattedResult;
  };
  return (
    <Row className="exam-reg-bill">
      <Modal
        wrapClassName="modal-custom-print"
        centered
        open={isShowModal}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        width={1000}
      >
        <div className="print-hoan-phi">
          <div ref={printRef} className="print">
            {/* <Row
              align={"middle"}
              justify={"space-between"}
              style={{ padding: "0px 24px 0 24px" }}
            >
              <Col span={22}>
                <Row>
                  <Typography.Text strong style={{ fontSize: "16px" }}>
                    Bệnh viện chuyên khoa mắt Alina
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <PhoneSVG />
                      <Typography.Text>0866224883</Typography.Text>
                    </Row>
                  </Col>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <LocationSVG />
                      <Typography.Text>
                        Xuân Giang, Văn Giang, Hưng Yên
                      </Typography.Text>
                    </Row>
                  </Col>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <MailSVG />
                      <Typography.Text>contact@alinavn.com</Typography.Text>
                    </Row>
                  </Col>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <InternetSVG />
                      <Typography.Text>alinavn.com</Typography.Text>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={2}>
                <Row justify={"end"}>
                  <img
                    src={logoBill}
                    style={{
                      height: "32px",
                    }}
                  />
                </Row>
              </Col>
            </Row> */}
            <HeaderPrintForm />
            <Row
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              <Row justify={"center"}>
                <Typography.Title
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                  }}
                >
                  GIẤY ĐỀ NGHỊ HOÀN DỊCH VỤ
                </Typography.Title>
              </Row>
              <Row>
                <Typography.Text
                  strong
                  style={{
                    fontWeight: "700",
                  }}
                >
                  Người đề nghị:{" "}
                  {thongTinIn?.nguoiDeNghi
                    ? thongTinIn?.nguoiDeNghi
                    : localStorage.getItem("fullName")}
                </Typography.Text>
              </Row>
              <Row>
                <Typography.Text
                  strong
                  style={{
                    fontWeight: "700",
                  }}
                >
                  Đề nghị hoàn cho bệnh nhân
                </Typography.Text>
              </Row>
              <Row>
                <Typography.Text
                  style={{
                    paddingLeft: "50px",
                  }}
                >
                  - Họ và tên: <strong>{thongTinIn?.hoTen}</strong>
                </Typography.Text>
              </Row>
              <Row>
                <Typography.Text
                  style={{
                    paddingLeft: "50px",
                  }}
                >
                  - Mã phiếu khám: <strong>{thongTinIn?.maPhieuKham}</strong>
                </Typography.Text>
              </Row>
              <Row>
                <Typography.Text
                  style={{
                    paddingLeft: "50px",
                  }}
                >
                  - Mã bệnh nhân: <strong>{thongTinIn?.maBenhNhan}</strong>
                </Typography.Text>
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Table
                  bordered
                  columns={columns}
                  dataSource={data}
                  style={{ width: "100%" }}
                  pagination={false}
                />
              </Row>
              <Row>
                <Space>
                  <Text>Tổng cộng :</Text>
                  <Typography.Text strong>
                    {formatToCurrencyType(thongTinIn?.tongCong)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    style={{ marginRight: "15px" }}
                  >
                    {getDateStringLocale(thongTinIn?.thoiGianHoan)}
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>Người bệnh</Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={64}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            Người đề nghị
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text type="secondary">
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          {tenThuNgan
                            ? tenThuNgan
                            : localStorage.getItem("fullName")}
                        </Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                </Row>
              </Row>
            </Row>
          </div>
        </div>
        <Row justify={"end"} style={{ padding: "12px", gap: "4px" }}>
          <Space direction="horizontal">
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              onAfterPrint={handleCancel}
              bodyClass="print-hoan-phi"
            />
          </Space>
        </Row>
      </Modal>
    </Row>
  );
};

export default ModalPrint;
